import { CUSTOMER_SERVICE_PHONE_NUMBER } from '@seek/shared-constants';

import type { EmployerSiteName } from 'src/types';
import { isANZSite } from 'src/utils/isSite';

export const getPhoneNumber = (site: EmployerSiteName) => {
  if (isANZSite(site)) {
    return CUSTOMER_SERVICE_PHONE_NUMBER[site];
  }
  return undefined;
};
